// extracted by mini-css-extract-plugin
module.exports = {"btn":"DiscordModalBody_btn__2--3e","title":"DiscordModalBody_title__25ZSp"};